/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Carousel } from 'client-code/wrs-feed-service';

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    THomeScreenFocusState,
    THomeScreenGhostState,
    THomeScreenState,
    TNavItem,
} from './homescreen.props';
import {
    LOAD_HOME_SCREEN_DATA,
    LOAD_HOME_SCREEN_MORE_CAROUSELS,
    LOAD_HOME_SCREEN_MORE_FEED_ITEMS,
    REFRESH_HOME_SCREEN,
    RESET_HOME_SCREEN,
    SET_HOME_SCREEN_ERROR,
    SET_HOME_SCREEN_FOCUS,
    SET_HOME_SCREEN_GHOST,
    SET_HOME_SCREEN_LOADING,
    SET_HOME_SCREEN_LOADING_MORE_CAROUSELS,
    SET_HOME_SCREEN_NAV_FOCUS,
    SET_HOME_SCREEN_NAV_ITEMS,
    SET_HOME_SCREEN_PREVIEW,
    SET_HOME_SCREEN_VERTICAL_SCROLL,
} from './homescreen.types';

export const loadHomeScreenDataAction = (
    carousels: Carousel[],
    pageCursor: string,
    refreshIntervalSecs: number,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: LOAD_HOME_SCREEN_DATA,
    payload: {
        carousels,
        pageCursor,
        refreshIntervalSecs,
        isLoading: false,
        isError: false,
        lastFetchTimestamp: Date.now(),
    },
});

export const loadMoreCarouselsAction = (
    carousels: Carousel[],
    pageCursor: string,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: LOAD_HOME_SCREEN_MORE_CAROUSELS,
    payload: {
        carousels,
        pageCursor,
    },
});

export const loadMoreFeedItemsAction = (
    carouselIndex: number,
    carousel: Carousel,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: LOAD_HOME_SCREEN_MORE_FEED_ITEMS,
    payload: {
        carousels: [carousel],
        // carouselIndex is carried in payload for the reducer to locate the target carousel
    } as any,
});

export const setHomeScreenFocusAction = (
    focusState: THomeScreenFocusState,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_FOCUS,
    payload: {
        focusState,
    },
});

export const setHomeScreenPreviewAction = (
    previewData: object | null,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_PREVIEW,
    payload: {
        previewData,
    },
});

export const setHomeScreenErrorAction = (
    isError: boolean,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_ERROR,
    payload: {
        isError,
        isLoading: false,
    },
});

export const setHomeScreenLoadingAction = (
    isLoading: boolean,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_LOADING,
    payload: {
        isLoading,
    },
});

export const setHomeScreenNavFocusAction = (
    navBarFocused: boolean,
    navBarIndex: number,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_NAV_FOCUS,
    payload: {
        navBarFocused,
        navBarIndex,
    },
});

export const setHomeScreenGhostAction = (
    ghostState: THomeScreenGhostState,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_GHOST,
    payload: {
        ghostState,
    },
});

export const setHomeScreenVerticalScrollAction = (
    verticalScrollIndex: number,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_VERTICAL_SCROLL,
    payload: {
        verticalScrollIndex,
    },
});

export const setHomeScreenLoadingMoreCarouselsAction = (
    isLoadingMoreCarousels: boolean,
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_LOADING_MORE_CAROUSELS,
    payload: {
        isLoadingMoreCarousels,
    },
});

export const setHomeScreenNavItemsAction = (
    navItems: TNavItem[],
): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: SET_HOME_SCREEN_NAV_ITEMS,
    payload: {
        navItems,
    },
});

export const resetHomeScreenAction = (): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: RESET_HOME_SCREEN,
    payload: {},
});

export const refreshHomeScreenAction = (): TivoPayloadAction<Partial<THomeScreenState>> => ({
    type: REFRESH_HOME_SCREEN,
    payload: {},
});
